
export default function Main() {

  return (
    <>
      <div style={{ height: "700px", background: `url(${require("../../assets/images/contacttop.png").default}) no-repeat center` }}></div>
    </>
  )
}